import { render, staticRenderFns } from "./Taxes.vue?vue&type=template&id=428801ea&scoped=true"
import script from "./Taxes.vue?vue&type=script&lang=js"
export * from "./Taxes.vue?vue&type=script&lang=js"
import style0 from "./Taxes.vue?vue&type=style&index=0&id=428801ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428801ea",
  null
  
)

export default component.exports